import {EventEmitter, Injectable, Output} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Machine} from '../model/machine';
import {MachinesService} from './machines.service';

@Injectable()
export class MachineDetailsService {

  @Output() routeChanged: EventEmitter<string> = new EventEmitter();

  public machine: Machine = null;

  private machineUuid: string;
  private isMachineLoading: boolean = true

  public machineSubject: BehaviorSubject<{ machineLoading: boolean, machine: Machine }> = new BehaviorSubject({
    machineLoading: true,
    machine: null
  });


  constructor(private readonly machinesService: MachinesService) {
  }

  public init(machineUuid: string): void {
    this.isMachineLoading = true;
    this.machineUuid = machineUuid;
    this.machineSubject.next({machineLoading: true, machine: null});
    this.getMachineByUuid(machineUuid);
  }

  private getMachineByUuid(machineUuid: string): void {
    this.machinesService.getMachine(machineUuid).subscribe(response => {
      this.machine = response.machine;
      this.isMachineLoading = false;
      this.machineSubject.next({machineLoading: false, machine: response.machine});
    });
  }

  get $notifier(): Observable<{ machineLoading: boolean, machine: Machine }> {
    this.machineSubject.next({machineLoading: true, machine: null});
    this.getMachineByUuid(this.machineUuid);
    return this.machineSubject.asObservable();
  }

  public cleanNotifier(): void {
    this.machine = null;
    this.isMachineLoading = true;
    this.machineSubject.next({machineLoading: true, machine: null});
  }

  public changeRoute(route: string): void {
    this.routeChanged.emit(route);
  }

}
